import { useEffect, useState } from 'react';

/**
 * Ob der Bildschirm unter `breakpoint` Pixel breit ist — generische Fassung
 * von `useIsNarrowViewport` (dort 1024px fest fuer die Werkbank-Stapel-Navigation).
 * `FeedSwitcher` braucht 768px (Popover vs. Drawer, Muster `use-mobile.tsx`).
 *
 * Bewusst ueber `window.innerWidth` + `resize` statt `matchMedia`: jsdom
 * implementiert `matchMedia` nicht, siehe der ausfuehrliche Kommentar in
 * `src/hooks/workbench/useIsNarrowViewport.ts`. Jede Komponente, die stattdessen
 * `matchMedia` ungeschuetzt aufruft, ist im Test nicht renderbar.
 */
export function useIsBelowBreakpoint(breakpoint: number): boolean {
  const [isBelow, setIsBelow] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint,
  );

  useEffect(() => {
    const onResize = () => setIsBelow(window.innerWidth < breakpoint);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isBelow;
}
